









import { listFactory } from '@/main/pages';
import hash from 'object-hash';
import _ from 'lodash';
import { NAME } from './constants';
import { store } from './store/list';
import { showAlert } from '@/main/utils/notifications';
import { PageMode } from '@/main/utils/pageMode';

export default listFactory(NAME, store).extend({
	methods: {
		async handleClose() {
			this.closeClick();
			if(this.table.rows.length === 0){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForNoRecordsFound'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
		},
	},
});
